





























import { mapActions } from 'vuex'
import { logout } from '@/services/auth'
import { navigateTo } from '@/router'
import TeamMemberInvitationDialog from './TeamMemberInvitationDialog.vue'
import LanguageDropdownSelect from './LanguageDropdownSelect.vue'

export default {
  components: {
    TeamMemberInvitationDialog,
    LanguageDropdownSelect
  },
  data() {
    return {
      inviteTeamMembersDialogOpen: false
    }
  },
  methods: {
    ...mapActions(['resetStore']),
    async handleClickLogout() {
      await logout()
      this.resetStore()
      navigateTo('/login')
    },
    openTeamMemberInvitationsDialog() {
      this.inviteTeamMembersDialogOpen = true
    },
    closeTeamMemberInvitationsDialog() {
      this.inviteTeamMembersDialogOpen = false
    }
  }
}
